import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export interface ListQuery {
  page?: number
  page_size?: number
  adv_ids?: string
  plan_ids?: string
  free?: number
  grant_type?: number
  grant_types?: string
  grant_scope?: number
  template_ids?: string
  channel_ids?: string
  permissions?: string
}

export interface OptionsQuery {
  page?: number
  page_size?: number
  name?: string
  option_type: string
}

export interface Supplement {
  delay_days: number
  download_num: number
  online_num: number
  parent_id: number
  revenue: number
  storage: number
  video_num: number
}

export interface Create {
  adv_id: number
  channel_ids: string
  days: number
  invoice_id: number
  plan_id: number
  revenue: number
  template_ids: number
}

export interface billQuery {
  adv_id?: number
  adv_ids?: number[]
  keyword?: string
  project_ids?: number[]
  basic_ids?: number[]
  time?: number[]
  stop_time?: number[]
  start_time?: number
  end_time?: number
  stop_time_begin?: number
  stop_time_end?: number
  is_test?: number
  status?: string[]
  page: number
  page_size: number
  search_field: string
}

export interface RechargeListQuery {
  page?: number
  page_size?: number
  search_field: string
  keyword: string
  money_max: number
  money_min: number
  start_time?: string
  end_time?: string
  order?: string
  status?: string
  export?: number
}

/**
 * 用户授权表
 * @param {*} params
 */
export function fetchGrantList(params: ListQuery) {
  return request({
    url: `${v2Host}/grant/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 授权补充套餐
 * @param {*} params
 */
export function grantSupplement(data: Supplement) {
  return request({
    url: `${v2Host}/grant/supplement`,
    method: 'post',
    data,
  })
}

/**
 * 用户授权表
 * @param {*} params
 */
export function fetchGrantPlans(params: { grant_type?: number }) {
  return request({
    url: `${v2Host}/grant/plans`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 获取grant options
 * @param {*} params
 */
export function fetchGrantOptions(params: OptionsQuery) {
  return request({
    url: `${v2Host}/grant/options`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 撤销授权
 * @param {*} params
 */
export function grantRevoke(data: { id: number; reason: string }) {
  return request({
    url: `${v2Host}/grant/revoke`,
    method: 'post',
    data,
  })
}

/**
 * 新增主套餐授权
 * @param {*} params
 */
export function createGrant(data: Create) {
  return request({
    url: `${v2Host}/grant/create`,
    method: 'post',
    data,
  })
}

/**
 * 更新授权信息
 * @param {*} params
 */
export function updateGrant(data: {
  channel_ids: string
  id: number
  template_ids: string
}) {
  return request({
    url: `${v2Host}/grant/update`,
    method: 'post',
    data,
  })
}

/**
 * 套餐升级
 * @param {*} params
 */
export function upgradeGrant(data: {
  id: number
  plan_id: number
  revenue: number
}) {
  return request({
    url: `${v2Host}/grant/upgrade`,
    method: 'post',
    data,
  })
}

/**
 * 授权记录
 * @param {*} params
 */
export function fetchGrantRecords(params: ListQuery) {
  return request({
    url: `${v2Host}/grant/records`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 获取金额
 * @param {*} data
 * @returns
 */
export function getGrantRevenue(data: any, withoutError = false) {
  // @ts-ignore
  return request({
    url: `${v2Host}/grant/revenue`,
    method: 'post',
    data,
    withoutError,
  })
}

/**
 * 授权激活
 * @param {*} data
 * @returns
 */
export function grantActivate(data: { id: number }) {
  return request({
    url: `${v2Host}/grant/activate`,
    method: 'post',
    data,
  })
}

/**
 * 充值记录
 * @param {*} params
 */
export function grantRechargeList(params: RechargeListQuery) {
  return request({
    url: `${v2Host}/grant/recharge/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 用户账户余额
 * @param {*} params
 */
export function grantBalanceList(params: { page: number; page_size: number }) {
  return request({
    url: `${v2Host}/grant/account-balance`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 添加充值
 * @param {*} data
 * @returns
 */
export function grantRechargeCreate(data: {
  adv_id: number
  currency: number
  money: number
  remark: string
}) {
  return request({
    url: `${v2Host}/grant/recharge/create`,
    method: 'post',
    data,
  })
}

/**
 * 退款
 * @param {*} data
 * @returns
 */
export function grantRechargeRefund(data: {
  id: number
  reason: string
  money: number
}) {
  return request({
    url: `${v2Host}/grant/recharge/refund`,
    method: 'post',
    data,
  })
}

/**
 * 更新用户最小余额
 * @param {*} data
 */
export function grantUpdateCredit(data: {
  support_credit: number
  adv_id: number
  min_amount: number
  approval_url: string
}) {
  return request({
    url: `${v2Host}/grant/update-credit`,
    method: 'post',
    data,
  })
}

/**
 * 创意消耗报表
 * @param {*} params
 */
export function billingCreativeList(params: billQuery) {
  return request({
    url: `${v2Host}/grant/billing-creative`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 素材消耗报表
 * @param {*} params
 */
export function billingMaterialList(params: billQuery) {
  return request({
    url: `${v2Host}/grant/billing-material`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
